import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';

/** Actions */
import { showAlert } from '../../store/ducks/alert';

/** Service */
import { sendEmail, getEmailKeys } from '../../services/emailSends';

/** Plugins */
import { Button, TextField } from '@material-ui/core';

/** Component */
import { Select, FormControl, InputLabel, MenuItem } from '@material-ui/core';

const EmailSends = () => {
  const dispatch = useDispatch();
  const [payload, setPayload] = useState();
  const [categories, setCategories] = useState([]);
  const [item, setItem] = useState();
  const [email, setEmail] = useState('');
  const [channelId, setChannelId] = useState();

  useEffect(() => {
    getCategories();
  }, []);

  const getCategories = async () => {
    try {
      let { data } = await getEmailKeys();
      data = Object.values(data).map(item => ({
        value: item,
        label: item,
      }));
      setCategories(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitForm = async payload => {
    try {
      await sendEmail(payload);
      dispatch(showAlert('success', 'Success! 🔥'));
      window.location = '/emailSends';
    } catch (error) {
      dispatch(showAlert('error', 'Error! Something went wrong. 😔'));
    }
  };
  return (
    <div className="email-container-full">
      <div className="email-container-full__top">
        <h2>{'Email Sends'}</h2>
      </div>
      <div div className="email-container-full__body">
        <div className="email-container-full__body__content">
          <div className="email-container-full__body__content__input">
            <FormControl className="email-fields-type" variant="outlined" data-testid="period-selector">
              <InputLabel>Categories</InputLabel>
              <Select
                value={categories[0]}
                onChange={e => {
                  setItem(e.target.value);
                }}
              >
                {categories.map(item => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="email-container-full__body__content__input">
            <TextField
              variant="outlined"
              label="Email"
              value={email}
              onChange={e => {
                setEmail(e.target.value);
              }}
            />
          </div>
          <div className="email-container-full__body__content__input">
            <TextField
              variant="outlined"
              label="ChannelId"
              value={channelId}
              onChange={e => {
                setChannelId(e.target.value);
              }}
            />
          </div>
        </div>
        <form className="email-container-full__form" noValidate autoComplete="off">
          <div className="email-container-full__form-input">
            <TextField
              className="email-container-full__form-input"
              label={`Payload`}
              value={payload}
              defaultValue={''}
              onChange={e => setPayload(e.target.value)}
              required={true}
              disabled={false}
              variant="outlined"
              multiline
              margin="none"
              rows={5}
            />
          </div>
        </form>
      </div>
      <Button onClick={() => handleSubmitForm({ payload, item, email, channelId })} variant="contained" className="email__btn">
        Confirm
      </Button>
    </div>
  );
};
export default EmailSends;
